/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Meow Mobile API
 * MeowStore 모바일 백엔드 API 명세
 * OpenAPI spec version: v1.0.0
 */
import type {
  CompleteAd2200,
  ForfeitRewards200,
  MulNyangAdCompleteRequest,
  MulNyangAdStartRequest,
  MulNyangAdminReloadResponse,
  MulNyangPlayClearRequest,
  MulNyangPlayFailRequest,
  MulNyangPlayRoundRequest,
  MulNyangPlayStartRequest,
  MulNyangRetryClickRequest,
  MulNyangRetryTimeRequest,
  MulNyangRewardForfeitRequest,
  PlayClear200,
  PlayFail200,
  PlayForfeit200,
  PlayStart1200,
  RetryClick200,
  RetryTime200,
  StartAd2200,
  State1200,
} from '.././model';

/**
 * @summary 물냥불냥 대기 보상 포기(clearBonus/streak/all)
 */
export type forfeitRewardsResponse200 = {
  data: ForfeitRewards200;
  status: 200;
};

export type forfeitRewardsResponseSuccess = forfeitRewardsResponse200 & {
  headers: Headers;
};
export type forfeitRewardsResponse = forfeitRewardsResponseSuccess;

export const getForfeitRewardsUrl = () => {
  return `/mul-nyang/rewards/forfeit`;
};

export const forfeitRewards = async (
  mulNyangRewardForfeitRequest: MulNyangRewardForfeitRequest,
  options?: RequestInit,
): Promise<forfeitRewardsResponse> => {
  const res = await fetch(getForfeitRewardsUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(mulNyangRewardForfeitRequest),
  });

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: forfeitRewardsResponse['data'] = body ? JSON.parse(body) : {};
  return { data, status: res.status, headers: res.headers } as forfeitRewardsResponse;
};

/**
 * @summary 물냥불냥 플레이 시작(간식 차감·서버 퍼즐 발급)
 */
export type playStart1Response200 = {
  data: PlayStart1200;
  status: 200;
};

export type playStart1ResponseSuccess = playStart1Response200 & {
  headers: Headers;
};
export type playStart1Response = playStart1ResponseSuccess;

export const getPlayStart1Url = () => {
  return `/mul-nyang/play/start`;
};

export const playStart1 = async (
  mulNyangPlayStartRequest: MulNyangPlayStartRequest,
  options?: RequestInit,
): Promise<playStart1Response> => {
  const res = await fetch(getPlayStart1Url(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(mulNyangPlayStartRequest),
  });

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: playStart1Response['data'] = body ? JSON.parse(body) : {};
  return { data, status: res.status, headers: res.headers } as playStart1Response;
};

/**
 * @summary 시간 초과 재도전(+5초/+3초, 간식 1개 또는 retryTime 광고)
 */
export type retryTimeResponse200 = {
  data: RetryTime200;
  status: 200;
};

export type retryTimeResponseSuccess = retryTimeResponse200 & {
  headers: Headers;
};
export type retryTimeResponse = retryTimeResponseSuccess;

export const getRetryTimeUrl = () => {
  return `/mul-nyang/play/retry/time`;
};

export const retryTime = async (
  mulNyangRetryTimeRequest: MulNyangRetryTimeRequest,
  options?: RequestInit,
): Promise<retryTimeResponse> => {
  const res = await fetch(getRetryTimeUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(mulNyangRetryTimeRequest),
  });

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: retryTimeResponse['data'] = body ? JSON.parse(body) : {};
  return { data, status: res.status, headers: res.headers } as retryTimeResponse;
};

/**
 * @summary 클릭 초과 재도전(+3클릭, 간식 1개 또는 retryClick 광고)
 */
export type retryClickResponse200 = {
  data: RetryClick200;
  status: 200;
};

export type retryClickResponseSuccess = retryClickResponse200 & {
  headers: Headers;
};
export type retryClickResponse = retryClickResponseSuccess;

export const getRetryClickUrl = () => {
  return `/mul-nyang/play/retry/click`;
};

export const retryClick = async (
  mulNyangRetryClickRequest: MulNyangRetryClickRequest,
  options?: RequestInit,
): Promise<retryClickResponse> => {
  const res = await fetch(getRetryClickUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(mulNyangRetryClickRequest),
  });

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: retryClickResponse['data'] = body ? JSON.parse(body) : {};
  return { data, status: res.status, headers: res.headers } as retryClickResponse;
};

/**
 * @summary 라운드 포기(연승 리셋·라운드 종료)
 */
export type playForfeitResponse200 = {
  data: PlayForfeit200;
  status: 200;
};

export type playForfeitResponseSuccess = playForfeitResponse200 & {
  headers: Headers;
};
export type playForfeitResponse = playForfeitResponseSuccess;

export const getPlayForfeitUrl = () => {
  return `/mul-nyang/play/forfeit`;
};

export const playForfeit = async (
  mulNyangPlayRoundRequest: MulNyangPlayRoundRequest,
  options?: RequestInit,
): Promise<playForfeitResponse> => {
  const res = await fetch(getPlayForfeitUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(mulNyangPlayRoundRequest),
  });

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: playForfeitResponse['data'] = body ? JSON.parse(body) : {};
  return { data, status: res.status, headers: res.headers } as playForfeitResponse;
};

/**
 * @summary 게임 실패 처리(재도전 소진, 연승 리셋)
 */
export type playFailResponse200 = {
  data: PlayFail200;
  status: 200;
};

export type playFailResponseSuccess = playFailResponse200 & {
  headers: Headers;
};
export type playFailResponse = playFailResponseSuccess;

export const getPlayFailUrl = () => {
  return `/mul-nyang/play/fail`;
};

export const playFail = async (
  mulNyangPlayFailRequest: MulNyangPlayFailRequest,
  options?: RequestInit,
): Promise<playFailResponse> => {
  const res = await fetch(getPlayFailUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(mulNyangPlayFailRequest),
  });

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: playFailResponse['data'] = body ? JSON.parse(body) : {};
  return { data, status: res.status, headers: res.headers } as playFailResponse;
};

/**
 * @summary 물냥불냥 클리어(즉시 포인트 지급·광고 보너스 대기)
 */
export type playClearResponse200 = {
  data: PlayClear200;
  status: 200;
};

export type playClearResponseSuccess = playClearResponse200 & {
  headers: Headers;
};
export type playClearResponse = playClearResponseSuccess;

export const getPlayClearUrl = () => {
  return `/mul-nyang/play/clear`;
};

export const playClear = async (
  mulNyangPlayClearRequest: MulNyangPlayClearRequest,
  options?: RequestInit,
): Promise<playClearResponse> => {
  const res = await fetch(getPlayClearUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(mulNyangPlayClearRequest),
  });

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: playClearResponse['data'] = body ? JSON.parse(body) : {};
  return { data, status: res.status, headers: res.headers } as playClearResponse;
};

/**
 * @summary 물냥불냥 광고 시작
 */
export type startAd2Response200 = {
  data: StartAd2200;
  status: 200;
};

export type startAd2ResponseSuccess = startAd2Response200 & {
  headers: Headers;
};
export type startAd2Response = startAd2ResponseSuccess;

export const getStartAd2Url = () => {
  return `/mul-nyang/ads/start`;
};

export const startAd2 = async (
  mulNyangAdStartRequest: MulNyangAdStartRequest,
  options?: RequestInit,
): Promise<startAd2Response> => {
  const res = await fetch(getStartAd2Url(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(mulNyangAdStartRequest),
  });

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: startAd2Response['data'] = body ? JSON.parse(body) : {};
  return { data, status: res.status, headers: res.headers } as startAd2Response;
};

/**
 * @summary 물냥불냥 광고 완료
 */
export type completeAd2Response200 = {
  data: CompleteAd2200;
  status: 200;
};

export type completeAd2ResponseSuccess = completeAd2Response200 & {
  headers: Headers;
};
export type completeAd2Response = completeAd2ResponseSuccess;

export const getCompleteAd2Url = () => {
  return `/mul-nyang/ads/complete`;
};

export const completeAd2 = async (
  mulNyangAdCompleteRequest: MulNyangAdCompleteRequest,
  options?: RequestInit,
): Promise<completeAd2Response> => {
  const res = await fetch(getCompleteAd2Url(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(mulNyangAdCompleteRequest),
  });

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: completeAd2Response['data'] = body ? JSON.parse(body) : {};
  return { data, status: res.status, headers: res.headers } as completeAd2Response;
};

/**
 * @summary 물냥불냥 설정 캐시 리로드
 */
export type reloadConfig1Response200 = {
  data: MulNyangAdminReloadResponse;
  status: 200;
};

export type reloadConfig1ResponseSuccess = reloadConfig1Response200 & {
  headers: Headers;
};
export type reloadConfig1Response = reloadConfig1ResponseSuccess;

export const getReloadConfig1Url = () => {
  return `/mul-nyang/admin/config/reload`;
};

export const reloadConfig1 = async (options?: RequestInit): Promise<reloadConfig1Response> => {
  const res = await fetch(getReloadConfig1Url(), {
    ...options,
    method: 'POST',
  });

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: reloadConfig1Response['data'] = body ? JSON.parse(body) : {};
  return { data, status: res.status, headers: res.headers } as reloadConfig1Response;
};

/**
 * @summary 물냥불냥 상태 조회
 */
export type state1Response200 = {
  data: State1200;
  status: 200;
};

export type state1ResponseSuccess = state1Response200 & {
  headers: Headers;
};
export type state1Response = state1ResponseSuccess;

export const getState1Url = () => {
  return `/mul-nyang/state`;
};

export const state1 = async (options?: RequestInit): Promise<state1Response> => {
  const res = await fetch(getState1Url(), {
    ...options,
    method: 'GET',
  });

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: state1Response['data'] = body ? JSON.parse(body) : {};
  return { data, status: res.status, headers: res.headers } as state1Response;
};
